import { useState, useReducer, useEffect } from "react";
// import { FlutterWaveButton, closePaymentModal } from "flutterwave-react-v3";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import Monnify from "monnify-js";
import * as Action from "../../../store/redux/registrationReducer.js";
import axios from "axios";
import "./RegistrationByAdmin.css";
import "./registration.css";
import Logo from "../public-routes-images/logos/Manga_Cons _Logo3.png";
import IsLoading from "../../../isLoading";
import { Link, useNavigate } from "react-router-dom";
import { statesAndLgas } from "./registrationStatesAndLGA.js";

let applicationData, appNo;

// ---- UI-only helpers (presentational, no state, no logic) -------------------
const REG_STEPS = ["Bio data", "Contact", "Payment"];

function RegStepper({ current }) {
  return (
    <ol className="mcr-stepper" aria-label="Application progress">
      {REG_STEPS.map((label, index) => {
        const stepNo = index + 1;
        const state =
          stepNo < current ? "is-done" : stepNo === current ? "is-current" : "";
        return (
          <li
            key={label}
            className={`mcr-step ${state}`.trim()}
            aria-current={stepNo === current ? "step" : undefined}
          >
            <span className="mcr-step-dot">{stepNo}</span>
            <span className="mcr-step-label">{label}</span>
          </li>
        );
      })}
    </ol>
  );
}

const controlClass = (hasError, extra = "") =>
  `mcr-control${extra ? ` ${extra}` : ""}${hasError ? " is-error" : ""}`;
// -----------------------------------------------------------------------------

export default function RegistrationByAdmin() {
  const { enqueueSnackbar } = useSnackbar();
  const redirect = useNavigate();
  const dispatch = useDispatch();

  // ****************************** GENERATING APPLICATION NUMBER FOR APPLICANTS **************************************

  // FUNTIONS FOR THE STATE SELECTIONS
  const [selectedState, setSelectedState] = useState("");
  const [localGovernments, setLocalGovernments] = useState([]);

  const handleStateChange = (e) => {
    const state = e.target.value;
    setSelectedState(state);
    setApplicantData({ state_of_address: e.target.value });
    setLocalGovernments(statesAndLgas[state] || []);
  };
  // ------------------------
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState("");

  const [newApplicant, setNewApplicant] = useState("");
  const [paidsuccessful, setPaidsuccessfull] = useState(false); //Ongoing Testing....
  // const [continueationData, setcontinueationData] = useState(null);
  let continueationData;
  const [switchForm, setSwitchForm] = useState(0);
  const date = new Date().toDateString;
  const [applicantData, setApplicantData] = useReducer(
    (request, response) => {
      return { ...request, ...response };
    },
    {
      ref_number: null,
      transaction_id: "",
      state_of_address: "",
      application_number: "",
    },
  );

  const $adminAuth = useSelector(
    (state) => state.adminFunction?.isAuthenticated,
  );

  const actions = useSelector((state) => state.applictaionForm);
  const fd1 = actions.firstDATA.appFormData;
  const fd2 = actions.secondDATA.appFormData;
  const [referenceNo, setreferenceNo] = useState(null);
  const [transactionId, setTransactionId] = useState(null);

  const executeApplication = async () => {
    setLoading(true);
    await axios
      .post(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/student_application`,
        data,
      )
      .then((response) => {
        console.log(response);
        applicationData = response.data.data;
        appNo = response.data?.data?.application_number;
        if (response.data?.status === 201) {
          setLoading(false);
          enqueueSnackbar(`${response.data.message}`, {
            variant: "success",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });

          setLoading(false);
        } else {
          enqueueSnackbar(`${response.data.message}`, {
            variant: "error",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        enqueueSnackbar(`error: something went wrong!`, {
          variant: "error",
          autoHideDuration: 3000,
          ContentProps: {
            style: { fontSize: "16px", fontWeight: "bold" },
          },
        });
        console.log(error);
        setLoading(false);
      });
  };
  const data = {
    first_name: fd1?.firstName,
    sur_name: fd1?.surName,
    other_name: fd1?.otherName,
    gender: fd1?.gender,
    email: fd1?.email,
    programme_of_study: fd1?.programme_of_study,
    course_of_study: fd1?.course_of_study,
    state_of_address: fd2?.state_of_address,
    lga_address: fd2?.lga_address,
    address: fd2?.address,
    phone_no: fd2?.phone_number,
    application_number: appNo,
    ref_number: referenceNo,
    transaction_id: transactionId,
  };

  const mailerData = {
    first_name: fd1?.firstName,
    sur_name: fd1?.surName,
    other_name: fd1?.otherName,
    application_number: fd2?.application_number,
    email: fd1?.email,
    programme_of_study: fd1?.programme_of_study,
    course_of_study: fd1?.course_of_study,
    ref_number: referenceNo,
    transaction_id: transactionId,
  };

  //   Payment Gateway Integration______________________________________

  const email = fd1?.email;
  const phone_number = fd2?.phone_number;
  const name = fd1?.firstName + " " + fd1?.surName + " " + fd1?.otherName;

  function RegPaymentBtn() {
    const monnify = new Monnify(
      `${process.env.REACT_APP_PAYMENTGATEWAY_API_KEY}`,
      `${process.env.REACT_APP_MY_CONTRACT_CODE}`,
    );

    function pay() {
      monnify.initializePayment({
        amount: 10000,
        currency: "NGN",
        reference: new Date().getTime(),
        customerFullName: name,
        customerEmail: email,
        paymentDescription:
          "Payment for Application form fee of MANGACONS Zuru ",
        metadata: {
          application_No: `${appNo}`,
          full_name: `${name}`,
          email: `${email}`,
          phone_number: `${phone_number}`,
        },
        onLoadStart: () => {
          console.log("Monnify SDK loading started");
        },
        onLoadComplete: () => {
          console.log("Monnify SDK is ready");
        },
        onComplete: (response) => {
          if (response.paymentStatus === "PAID") {
            setreferenceNo(response.paymentReference);
            setTransactionId(response.transactionReference);
            executeApplication();
          } else {
            console.log("Payment Failed");
          }
          console.log("Transaction complete:", response);
        },
        onClose: (response) => {
          console.log("Payment modal closed:", response);
        },
      });
    }
    return (
      <button className="mcr-btn mcr-btn--primary" onClick={() => pay()}>
        Pay now
      </button>
    );
  }

  useEffect(() => {
    if (appNo) {
      redirect(`/registrations/${appNo}/print_reciept`);
    }
  }, [appNo]);

  // const config = {
  //   public_key: `${process.env.REACT_APP_PAYMENT_GATE_KEY}`,
  //   // public_key: `FLWPUBK_TEST-11dd15a3cd552223b958000b7ed835f5-X`,
  //   tx_ref: Date.now(),
  //   amount: 10000,
  //   currency: "NGN",
  //   payment_options: "card,mobilemoney,ussd",
  //   customer: {
  //     application_No,
  //     name,
  //     email,
  //     phone_number,
  //   },
  //   customizations: {
  //     title: "MANGA C.O.N.S",
  //     description: "Payment for Application form",
  //     logo: "https://mangaconszurufilesbucket.s3.eu-north-1.amazonaws.com/1738333704870_Manga_Cons _Logo3.8a66ad505d6e3f3e47d9.png",
  //   },
  // };
  // function showSuccess() {
  //   setSwitchForm("success");
  // }
  // const fwConfig = {
  //   ...config,
  //   text: "Pay now!",
  //   callback: async (response) => {
  //     setLoading(true);
  //     closePaymentModal(); // Close modal programmatically
  //     if (response.status === "successful") {
  //       setreferenceNo(response.tx_ref);
  //       setTransactionId(response.transaction_id);
  //       // setSwitchForm("success");
  //       setLoading(false);
  //     } else {
  //       console.log("Payment Failed");
  //       setLoading(false);
  //     }
  //   },
  //   onClose: () => {},
  // };

  // end of payment gateway integration_____________________________

  const formSwitching = () => {
    switch (switchForm) {
      case 1:
        return <FormData />;
      case 2:
        return <FormData2 />;
      case 3:
        return <PaymentDetails />;
      // case "success":
      //   return <FormPaidStatus />;
      default:
        return "";
    }
  };

  const [AppNo, setAppNo] = useState("");

  const DispatchContinuetion = () => async (dispatch) => {
    try {
      dispatch(Action.continueAppForm({ continueationData }));
    } catch (error) {
      console.log(error);
    }
  };
  async function executionAppVerification() {
    const application_number = AppNo;
    setLoading(true);
    await axios
      .post(`${process.env.REACT_APP_SERVER_SCRIPT_HOST}/verify_applicant`, {
        application_number,
      })

      .then((response) => {
        // setcontinueationData(response.data.data);
        continueationData = response.data.data;
        if (response.data.data.account_status?.paymentStatus === "success") {
          // setPaidsuccessfull(true);
          dispatch(DispatchContinuetion());
          redirect(
            `/continue_application/${response.data.data.application_number}`,
          );
          setLoading(false);
        } else {
          alert("Invalid Application Number");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }

  const FormData = () => {
    const [appFormData, setAppFormData] = useReducer(
      (request, response) => {
        return { ...request, ...response };
      },
      {
        firstName: "",
        surName: "",
        otherName: "",
        gender: "",
        email: "",
        programme_of_study: "",
        course_of_study: "",
      },
    );

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
      firstName: Yup.string().required("First name is required"),
      surName: Yup.string().required("Sur name is required"),
      // otherName: Yup.string().required("Other name is required"),
      gender: Yup.string().required("Gender is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      programme_of_study: Yup.string().required("Programme is required"),
      course_of_study: Yup.string().required("Course of study is required"),
    });

    const validateForm = async () => {
      try {
        await validationSchema.validate(appFormData, { abortEarly: false });
        setErrors({});
        return true; // Form is valid
      } catch (validationErrors) {
        const formattedErrors = {};
        validationErrors.inner.forEach((error) => {
          formattedErrors[error.path] = error.message;
        });
        setErrors(formattedErrors);
        return false; // Form is invalid
      }
    };

    const execute = async () => {
      const isValid = await validateForm();
      if (isValid) {
        setIsSubmitting(true);
        dispatch(Action.startappFormAction({ appFormData }));
        setSwitchForm(2);
      }
    };

    return (
      <>
        <header className="mcr-head">
          <RegStepper current={1} />
          <h2 className="mcr-title">Bio Data</h2>
        </header>
        <div className="mcr-grid-2">
          <div className="mcr-field">
            <label className="mcr-label" htmlFor="mcr-first-name">
              First name:
            </label>
            <div className={controlClass(errors.firstName)}>
              <input
                id="mcr-first-name"
                value={appFormData.firstName}
                onChange={(event) =>
                  setAppFormData({ firstName: event.target.value })
                }
                type="text"
                name="first_name"
              />
              {/* {errors.firstName && (
                <div style={{ color: "red" }}>{errors.firstName}</div>
              )} */}
            </div>
          </div>
          <div className="mcr-field">
            <label className="mcr-label" htmlFor="mcr-sur-name">
              Sur name:
            </label>
            <div className={controlClass(errors.surName)}>
              <input
                id="mcr-sur-name"
                value={appFormData.surName}
                onChange={(event) =>
                  setAppFormData({ surName: event.target.value })
                }
                type="text"
                name="sur_name"
              />
              {/* {errors.surName && (
                <div style={{ color: "red" }}>{errors.surName}</div>
              )} */}
            </div>
          </div>
        </div>
        <div className="mcr-grid-2">
          <div className="mcr-field">
            <label className="mcr-label" htmlFor="mcr-other-name">
              Other name:
            </label>
            <div className={controlClass(errors.otherName)}>
              <input
                id="mcr-other-name"
                value={appFormData.otherName}
                onChange={(event) =>
                  setAppFormData({ otherName: event.target.value })
                }
                type="text"
                name="other_name"
              />
            </div>
          </div>
          <div className="mcr-field">
            <label className="mcr-label" htmlFor="mcr-gender">
              Gender:
            </label>
            <div className={controlClass(errors.gender)}>
              <select
                id="mcr-gender"
                value={appFormData.gender}
                onChange={(event) =>
                  setAppFormData({ gender: event.target.value })
                }
                name="gender"
              >
                <option value="" disabled hidden>
                  Select gender
                </option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
              {/* {errors.gender && (
                <div style={{ color: "red" }}>{errors.gender}</div>
              )} */}
            </div>
          </div>
        </div>
        <div className="mcr-field">
          <label className="mcr-label" htmlFor="mcr-email">
            Email:
          </label>
          <div className={controlClass(errors.email)}>
            <input
              id="mcr-email"
              value={appFormData.email}
              onChange={(event) =>
                setAppFormData({ email: event.target.value })
              }
              type="email"
              name="email"
            />
            {/* {errors.email && <div style={{ color: "red" }}>{errors.email}</div>} */}
          </div>
        </div>
        <div className="mcr-grid-2">
          <div className="mcr-field">
            <label className="mcr-label" htmlFor="mcr-programme">
              Programme:
            </label>
            <div className={controlClass(errors.programme_of_study)}>
              <select
                id="mcr-programme"
                value={appFormData.programme_of_study}
                onChange={(event) =>
                  setAppFormData({ programme_of_study: event.target.value })
                }
                name="programme_of_study"
              >
                <option disabled hidden>
                  Select programme of choice
                </option>
                <option value="" disabled hidden>
                  Select programme
                </option>
                {/* <option value="national diploma">ND</option> */}
                <option value="ND/HND">ND/HND</option>
              </select>
              {/* {errors.programme_of_study && (
                <div style={{ color: "red" }}>{errors.programme_of_study}</div>
              )} */}
            </div>
          </div>
          <div className="mcr-field">
            <label className="mcr-label" htmlFor="mcr-course">
              Course of study:
            </label>
            <div className={controlClass(errors.course_of_study)}>
              <select
                id="mcr-course"
                value={appFormData.course_of_study}
                onChange={(event) =>
                  setAppFormData({ course_of_study: event.target.value })
                }
                name="programme_of_study"
              >
                <option disabled hidden>
                  Select programme of choice
                </option>
                <option value="" disabled hidden>
                  Select programme
                </option>
                <option value="Midwifery">Midwifery</option>
                <option value="General Nursing">General Nursing</option>
              </select>
              {/* {errors.programme_of_study && (
                <div style={{ color: "red" }}>{errors.programme_of_study}</div>
              )} */}
            </div>
          </div>
        </div>
        <div className="mcr-actions mcr-actions--end">
          <span className="mcr-spacer">&nbsp;</span>
          <button
            className="mcr-btn mcr-btn--primary"
            onClick={execute}
            disabled={isSubmitting}
          >
            Next
          </button>
        </div>
      </>
    );
  };

  const FormData2 = () => {
    const [appFormData, setAppFormData] = useReducer(
      (request, response) => {
        return { ...request, ...response };
      },
      {
        application_number: applicantData.application_number,
        state_of_address: applicantData.state_of_address,
        lga_address: "",
        address: "",
        phone_number: "",
        ref_number: "",
        transaction_id: "",
      },
    );
    const [errors, setErrors] = useState({}); // State to hold validation errors

    const DispatchappFormData = () => async (dispatch) => {
      try {
        dispatch(Action.startappFormCont({ appFormData }));
      } catch (error) {
        console.log(error);
      }
    };

    const validateForm = () => {
      let validationErrors = {};
      if (!appFormData.lga_address) {
        validationErrors.lga_address = "Local Gov't Area is required.";
      }
      if (!appFormData.address) {
        validationErrors.address = "Contact address is required.";
      }
      if (!appFormData.phone_number) {
        validationErrors.phone_number = "Phone number is required.";
      } else if (!/^\d{10}$/.test(appFormData.phone_number)) {
        validationErrors.phone_number = "Phone number must be 10 digits.";
      }

      setErrors(validationErrors);
      return Object.keys(validationErrors).length === 0; // Returns true if no errors
    };

    function execute() {
      if (!AppNo && validateForm()) {
        dispatch(DispatchappFormData());
        setSwitchForm(3);
      }
    }

    return (
      <>
        <header className="mcr-head">
          <RegStepper current={2} />
          <h2 className="mcr-title">Contact address</h2>
        </header>
        <div className="mcr-grid-2">
          <div className="mcr-field">
            <label className="mcr-label" htmlFor="mcr-state">
              State:
            </label>
            <div className={controlClass(errors.state)}>
              <select
                id="mcr-state"
                value={selectedState}
                onChange={handleStateChange}
              >
                <option value="" hidden>
                  Select state
                </option>
                {Object.keys(statesAndLgas).map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="mcr-field">
            <label className="mcr-label" htmlFor="mcr-lga">
              Local Gov't Area:
            </label>
            <div className={controlClass(errors.lga_address)}>
              <select
                id="mcr-lga"
                disabled={!selectedState}
                value={appFormData.lga_address}
                onChange={(event) =>
                  setAppFormData({ lga_address: event.target.value })
                }
              >
                <option value="" hidden>
                  Select LGA
                </option>
                {localGovernments.map((lga) => (
                  <option key={lga} value={lga}>
                    {lga}
                  </option>
                ))}
              </select>
              {/* {errors.lga_address && (
                <p className="error">{errors.lga_address}</p>
              )} */}
            </div>
          </div>
        </div>
        <div className="mcr-field">
          <label className="mcr-label" htmlFor="mcr-address">
            Contact address:
          </label>
          <div className={controlClass(errors.address, "mcr-control--area")}>
            <textarea
              id="mcr-address"
              value={appFormData.address}
              onChange={(event) =>
                setAppFormData({ address: event.target.value })
              }
              name="address"
              cols="30"
              rows="10"
            ></textarea>
            {/* {errors.address && <p className="error">{errors.address}</p>} */}
          </div>
        </div>

        <div className="mcr-field">
          <label className="mcr-label" htmlFor="mcr-phone">
            Phone number:
          </label>
          <div
            className={controlClass(errors.phone_number, "mcr-control--phone")}
          >
            <div className="mcr-prefix">
              <span className="mcr-flag" aria-hidden="true">
                <span className="mcr-flag-stripe"></span>
                <span className="mcr-flag-stripe is-white"></span>
                <span className="mcr-flag-stripe"></span>
              </span>
              <span>+234</span>
            </div>
            <input
              id="mcr-phone"
              value={appFormData.phone_number}
              onChange={(event) =>
                setAppFormData({ phone_number: event.target.value })
              }
              type="number"
              name="phone_no"
            />
            {/* {errors.phone_number && (
              <p className="error">{errors.phone_number}</p>
            )} */}
          </div>
        </div>
        <div className="mcr-actions">
          <button
            className="mcr-btn mcr-btn--secondary"
            onClick={() => setSwitchForm(1)}
          >
            Prev
          </button>
          <button
            className="mcr-btn mcr-btn--primary"
            onClick={() => execute()}
          >
            Continue
          </button>
        </div>
      </>
    );
  };

  const PaymentDetails = () => {
    async function wakeUP() {
      await axios
        .get(`${process.env.REACT_APP_SERVER_SCRIPT_HOST}/wakeUP`)
        .then((response) => {
          console.log("live");
        })
        .catch((error) => {
          console.log(error);
        });
    }
    useEffect(() => {
      wakeUP();
    }, []);
    return (
      <>
        <header className="mcr-head">
          <RegStepper current={3} />
          <h2 className="mcr-title">Payment summary</h2>
        </header>
        <div className="mcr-receipt">
          <h3 className="mcr-receipt-head">
            <span>Application form</span>
            <strong>N10,000.00</strong>
          </h3>
          <div className="mcr-receipt-body">
            <div className="mcr-receipt-note">
              <strong>
                You are about to pay for Manga CONS application form
              </strong>
            </div>
            <div className="mcr-receipt-row">
              <strong>Description:</strong> <span>Manga CONS Form Fee</span>
            </div>
            <div className="mcr-receipt-row">
              <strong>Amount:</strong> <span>N10,000</span>
            </div>
            <div className="mcr-receipt-row is-divided">
              <strong>Beneficiary:</strong>
              <span>Manga College of Nursing Sciences</span>
            </div>
            <div className="mcr-receipt-row is-total">
              <strong>Total amount:</strong> <span>N10,000</span>
            </div>
          </div>
        </div>

        <div className="mcr-actions">
          <button
            className="mcr-btn mcr-btn--secondary"
            onClick={() => setSwitchForm(2)}
          >
            Prev
          </button>
          {$adminAuth ? (
            <div className="mcr-actions-group">
              <RegPaymentBtn />
              <button
                className="mcr-btn mcr-btn--success"
                onClick={() => executeApplication()}
              >
                Direct Submit
              </button>
            </div>
          ) : (
            <RegPaymentBtn />
          )}
        </div>
      </>
    );
  };

  function handleNewApp() {
    // alert(
    //   "The Application Form for General Nursing will be open on 20th September 2025. Thank you."
    // );
    setNewApplicant("new-application");
    setSwitchForm(1);
  }
  function handleExistedApp() {
    // alert(
    //   "The Application Form for General Nursing will be open on 20th September 2025. Thank you."
    // );
    setNewApplicant("continue-application");
  }

  return (
    <>
      {loading ? <IsLoading /> : null}
      <section className="mcr-page">
        <div className={`mcr-shell is-step-${switchForm}`}>
          {/* ---------- Brand panel ---------- */}
          <div className="mcr-aside">
            <div className="mcr-logo-tile">
              <img className="mcr-logo" src={Logo} alt="logo" />
            </div>

            <div className="mcr-intro">
              {/* <h4>Applicantion is CLOSED</h4> */}
              <h4 className="mcr-badge mcr-badge--on-dark">
                Application is now Open!!
              </h4>
              {/* <p>
                The 2025/2026 Application Form for enterance into the ND/HND
                <strong> General Nursing</strong> of Manga College of Nursing
                Sciences will be open on 20th September 2025 and closes on 20th
                October, 2025.
              </p> */}
              <p className="mcr-lead">
                Application Form 2026/2027 for entrance into the ND/HND{" "}
                <strong>General Nursing program</strong> of Manga College of
                Nursing Sciences is now <strong>Open</strong> on 15th July 2026
                and will be close on 15th November 2025
                {/* now Open! and will be close on 30th November
                2025 */}
              </p>

              {/* <p>
                However, the 2024/2025 Application Form for enterance into the{" "}
                <strong>Basic Midwifery Programme</strong> of Manga College of
                Nursing Sciences has been closed on 17th September, 2025
              </p> */}
            </div>
            {switchForm === 0 ? (
              <div className="mcr-aside-actions">
                <button
                  className="mcr-btn mcr-btn--light mcr-btn--block"
                  onClick={() => handleNewApp()}
                >
                  Start new application
                </button>
                <button
                  className="mcr-btn mcr-btn--ghost-light mcr-btn--block"
                  onClick={() => handleExistedApp()}
                >
                  Continue Application
                </button>
              </div>
            ) : null}

            <svg
              className="mcr-ecg"
              viewBox="0 0 600 120"
              preserveAspectRatio="none"
              aria-hidden="true"
              focusable="false"
            >
              <path
                className="mcr-ecg-base"
                vectorEffect="non-scaling-stroke"
                d="M0 70 H140 l12 -8 l12 8 H200 l10 8 l14 -62 l16 96 l12 -42 H330 l14 -10 l16 10 H600"
              />
              <path
                className="mcr-ecg-pulse"
                pathLength="100"
                vectorEffect="non-scaling-stroke"
                d="M0 70 H140 l12 -8 l12 8 H200 l10 8 l14 -62 l16 96 l12 -42 H330 l14 -10 l16 10 H600"
              />
            </svg>
          </div>

          {/* ---------- Right panel ---------- */}
          {newApplicant === "continue-application" ? (
            <div className="mcr-form-panel mcr-form-panel--verify">
              <div className="mcr-mobile-brand">
                <img src={Logo} alt="logo" />
              </div>
              <div className="mcr-verify">
                <h2 className="mcr-title">Continue application</h2>
                <div className="mcr-field">
                  <label className="mcr-label" htmlFor="mcr-app-no">
                    Application number
                  </label>
                  <div className="mcr-control">
                    <input
                      id="mcr-app-no"
                      value={AppNo}
                      onChange={(event) => {
                        setAppNo(event.target.value);
                      }}
                      type="text"
                      name="application_number"
                      placeholder="Enter application no..."
                    />
                  </div>
                </div>
                <button
                  className="mcr-btn mcr-btn--primary mcr-btn--block"
                  onClick={() => executionAppVerification()}
                >
                  Verify Application
                </button>
              </div>
            </div>
          ) : (
            <div
              className={`mcr-form-panel${switchForm === 0 ? " is-welcome" : ""}`}
            >
              <div className="mcr-mobile-brand">
                <img src={Logo} alt="logo" />
              </div>

              {switchForm === 0 ? (
                <div className="mcr-welcome">
                  <h2 className="mcr-welcome-title">Apply in three steps</h2>
                  <ol className="mcr-welcome-list">
                    <li className="mcr-welcome-item">
                      <span className="mcr-welcome-num">1</span>
                      <div>
                        <h3>Bio data</h3>
                        <p>
                          Your name, gender, email, programme and course of
                          study.
                        </p>
                      </div>
                    </li>
                    <li className="mcr-welcome-item">
                      <span className="mcr-welcome-num">2</span>
                      <div>
                        <h3>Contact address</h3>
                        <p>
                          Your state, local government area, address and phone
                          number.
                        </p>
                      </div>
                    </li>
                    <li className="mcr-welcome-item">
                      <span className="mcr-welcome-num">3</span>
                      <div>
                        <h3>Payment</h3>
                        <p>
                          Pay the N10,000 application form fee to submit your
                          application.
                        </p>
                      </div>
                    </li>
                  </ol>
                </div>
              ) : null}

              <div className="mcr-form-wrap" key={switchForm}>
                {formSwitching()}
              </div>
              {switchForm == 1 ? (
                <aside className="mcr-footnote">
                  already have an account? &nbsp;
                  <Link to={`/student_login`}>
                    <strong>Sign in</strong>
                  </Link>
                </aside>
              ) : (
                <>
                  {switchForm === 0 ? (
                    <div className="mcr-mobile-start">
                      <div className="mcr-mobile-intro">
                        <img
                          className="mcr-mobile-logo"
                          src={Logo}
                          alt="logo"
                        />
                        <h4 className="mcr-badge">Application is now Open!!</h4>
                        <p className="mcr-lead">
                          Application Form 2024/2025 for entrance into the
                          ND/HND <strong>General Nursing program</strong> of
                          Manga College of Nursing Sciences now Open! and will
                          be close on 30th November 2025
                        </p>

                        <p className="mcr-lead">
                          However, the 2024/2025 Application Form for entrance
                          into the <strong>Basic Midwifery Programme</strong> of
                          Manga College of Nursing Sciences has been closed on
                          17th September, 2025
                        </p>
                      </div>
                      <button
                        className="mcr-btn mcr-btn--primary mcr-btn--block"
                        onClick={() => handleNewApp()}
                      >
                        Start new application
                      </button>

                      <button
                        className="mcr-btn mcr-btn--secondary mcr-btn--block"
                        onClick={() => handleExistedApp()}
                      >
                        Continue Application
                      </button>
                    </div>
                  ) : null}

                  <aside className="mcr-copyright">
                    copyright &copy; manga-cons
                    {new Date().getFullYear() + " "}
                    <Link>
                      <strong>all rights reserved</strong>
                    </Link>
                  </aside>
                </>
              )}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
